import { createClient } from "graphql-ws";
import { HOST_MODES, initialModeList } from "@/constants";
import { addConversation, uploadChatHistory } from "@/core/api/api";
import { v4 as uuidv4 } from "uuid";
import { useMainLayoutStore, } from "../../zustand/mainLayoutStore";
import useAuthStore from "../../zustand/authStore";
import useToastStore from "../../zustand/toastStore";
import { config } from "@/config";
import { encodeParam, extractWaitMessage, replaceAsteriskInAnchor, } from "../helpers";
import { updateUserChatAndHistory } from "./appLayoutUtilities";
const chatAssistantName = config.VITE_ASSISTANT_NAME;
const organizationName = "techolution";
export const getAssistantObj = (event, accordianMessageArray) => {
    const streamedresponse = {
        role: "assistant",
        content: "",
        id: uuidv4(),
    };
    //orchestrator is sending message, we initially set it as normal message
    if (event.data.chatStream.continueChatResult.thinking_break === false &&
        event.data.chatStream.continueChatResult.is_orchestrator === true &&
        event.data.chatStream.continueChatResult.isEnd === false) {
        streamedresponse.content = replaceAsteriskInAnchor(event.data.chatStream.continueChatResult.message.content)?.replace(/WaitMessage: /g, "");
    }
    //orchestrator is sending message and thinking break is there, we add it to accordian
    if (event.data.chatStream.continueChatResult.thinking_break === true &&
        event.data.chatStream.continueChatResult.is_orchestrator === true &&
        event.data.chatStream.continueChatResult.isEnd === false) {
        //check for wait message deletion
        streamedresponse.content = "";
        accordianMessageArray.push({
            responsedata: event.data.chatStream.continueChatResult.message.content,
            responseFrom: event.data.chatStream.continueChatResult.responded_by,
            header_message: event.data.chatStream.continueChatResult.header_message,
            finalResponseStatus: false,
        });
    }
    //orchestrator replied with the final message, this is the final response, no need for accordian
    if (event.data.chatStream.continueChatResult.thinking_break === false &&
        event.data.chatStream.continueChatResult.is_orchestrator === true &&
        event.data.chatStream.continueChatResult.isEnd === true) {
        streamedresponse.content = replaceAsteriskInAnchor(event.data.chatStream.continueChatResult.message.content)?.replace(/WaitMessage: /g, "");
    }
    //agent responded it will directly be shown in collapsed form
    if (event.data.chatStream.continueChatResult.thinking_break === false &&
        event.data.chatStream.continueChatResult.is_orchestrator === false &&
        event.data.chatStream.continueChatResult.isEnd === false) {
        accordianMessageArray = [
            ...accordianMessageArray,
            {
                responsedata: event.data.chatStream.continueChatResult.message.content,
                responseFrom: event.data.chatStream.continueChatResult.responded_by,
                header_message: event.data.chatStream.continueChatResult.header_message,
                finalResponseStatus: true,
            },
        ];
    }
    //final response from agent
    if (event.data.chatStream.continueChatResult.thinking_break === true &&
        event.data.chatStream.continueChatResult.is_orchestrator === false &&
        event.data.chatStream.continueChatResult.isEnd === false) {
        accordianMessageArray.push({
            responsedata: event.data.chatStream.continueChatResult.message.content,
            responseFrom: event.data.chatStream.continueChatResult.responded_by,
            header_message: event.data.chatStream.continueChatResult.header_message,
            finalResponseStatus: false,
        });
    }
    const annotations = event?.data?.chatStream?.continueChatResult?.message?.annotations;
    let assistantObj = {
        role: "assistant",
        content: streamedresponse.content,
        orchestratorAndAgentsMessages: accordianMessageArray,
        time: new Date(),
        id: event.data.chatStream.continueChatResult.requestId ?? "",
        requestId: event.data.chatStream.continueChatResult.requestId ?? "",
        citations: event.data.chatStream.continueChatResult.message.citations,
        annotations: annotations,
        resourceId: event.data.chatStream.continueChatResult.resourceId,
        citationDisplayType: event.data.chatStream.continueChatResult.message.citationDisplayType ??
            "",
        isStreamEnd: event?.data?.chatStream?.continueChatResult?.isEnd || false,
    };
    if (annotations) {
        for (let index = 0; index < annotations?.length; index++) {
            const annotation = annotations[index];
            assistantObj = {
                ...assistantObj,
                content: assistantObj?.content?.replace(annotation?.text, annotation?.text + `<sup>${index}</sup>`),
            };
        }
    }
    // sending both assistantObj and isEnd
    return {
        assistantObject: assistantObj,
        isEnd: event.data.chatStream.continueChatResult.isEnd,
    };
};
export const processMessage = async (userQuery, isFirstMessage, newChatId, 
// states and its handlers
sessionId, replyMessage, streamingMessages, chatId, chatIdRef, callbacks, triggerFeedback) => {
    const { user, isLoggedIn } = useAuthStore.getState();
    // const setToastRef = useToastStore((state) => state.setToastRef);
    const { showToast } = useToastStore.getState();
    const { currentHostMode, modesHistory, activeMode, modeList, remoteLoadedInfo, hostLoadedInfo, modeNameToAssistantName, manualSelectionData, setModesHistory, setCurrentHostMode, setActiveMode, setIsWidgetTypeChange, setIsCurrentHostChanged, setRemoteLoadedInfo, setHostLoadedInfo, } = useMainLayoutStore.getState();
    const { setReplyMessage, setMessageLoading, setWaitMessageLoading, setStreamingMessages, setRenderDone, setIsStreaming, setResponseMessage, } = callbacks;
    let client = null;
    try {
        setReplyMessage("");
        const modeListString = [...modeList, ...initialModeList]
            .map((widget) => JSON.stringify({
            mode: widget.modeName,
            Name: widget.modeName,
            Description: widget.description,
        }, null, 2))
            .join(",\n");
        const formattedQuery = `User Query: ${userQuery}\n\nWidget List: [\n${modeListString}\n] Current Mode: ${activeMode || currentHostMode}\n\n`;
        // console.log("Formatted Query:", formattedQuery);
        const query = userQuery;
        setMessageLoading(true);
        setWaitMessageLoading(false);
        const requestId = `requestId-${uuidv4()}`;
        const userQuestionTime = new Date();
        const userMessage = {
            id: requestId,
            role: "user",
            content: query,
            time: userQuestionTime,
        };
        setStreamingMessages((prevMsgs) => [...prevMsgs, userMessage]);
        if (isFirstMessage && newChatId && isLoggedIn && user?.email) {
            // console.log("CALLING post call for the first time");
            const { responseData, error } = await uploadChatHistory(newChatId, user?.email, [...streamingMessages, userMessage]);
            if (error) {
                console.error("Error in creating the chat history for this newChatId", newChatId, error.errorObjData);
                showToast("error", "Error", error.errorMessage); // commenting this for today
                return;
            }
            else {
                // console.log("Successfully created chat history", responseData);
            }
            if (user && user.email) {
                const urlObject = new URL(window.location.href);
                const urlProjectId = urlObject.searchParams.get("projectId");
                const artifactId = urlObject.searchParams.get("artifactId");
                // console.log("printing-- first message","urlProjectId", urlProjectId,"artifactId", artifactId);
                const chatData = {
                    chatId: newChatId,
                    projectId: urlProjectId ?? null,
                    artifactId: artifactId ?? null,
                };
                // old api
                // const { responseData, error } = await updateUserChat(
                //   user?.email,
                //   JSON.stringify(chatData)
                // );
                const { responseData, error } = await addConversation(user?.email, newChatId, artifactId ?? "", urlProjectId ?? ""); // new api
                if (error) {
                    console.error("Error updating user chat", error);
                    showToast("error", "Error", error.errorMessage);
                    return;
                }
                else {
                    // console.log("Updated user chat in upload", responseData);
                }
            }
        }
        // here i have to check to bypass the orchestrator or not;
        if (manualSelectionData.isSelected &&
            manualSelectionData.modeName.length > 0 &&
            modesHistory.length > 0 &&
            modesHistory[modesHistory.length - 1].mode ===
                manualSelectionData.modeName) {
            console.log("*****bypassing the Orchestrator****", modesHistory);
            setIsWidgetTypeChange(true);
            return;
        }
        client = await createClient({
            url: config.VITE_WEBSOCKET_URL ?? "",
        });
        const assistantName = config.VITE_ASSISTANT_NAME;
        const subscription = client.iterate({
            query: `subscription Subscription($guestSessionId: String!, $sessionId: String!, $name:String!, $organizationName:String!, $aiModel:String!, $prompt:String!, $userName:String!, $userEmailId:String!, $userId:String!, $requestId:String!,$replyMessage:String!,$customPrompt:String, $notificationSessionId:String,$images:String) {
            chatStream(guestSessionId: $guestSessionId, sessionId: $sessionId, name:$name, organizationName:$organizationName, aiModel:$aiModel, prompt:$prompt, userName:$userName, userEmailId:$userEmailId, userId:$userId, requestId:$requestId, replyMessage:$replyMessage, customPrompt:$customPrompt, notificationSessionId:$notificationSessionId,images:$images) {
              continueChatResult {
                isEnd
                thinking_break
                is_orchestrator
                is_agent
                responded_by
                header_message
                confidenceScore
                requestId
                replyMessage
                sessionId
                message {
                  citations {
                    citation_number
                    title
                    url
                    description
                    metadata {
                      page_index
                    }
                  }
                  annotations {
                    citations {
                      citation_number
                      title
                      url
                      description
                      metadata {
                        page_index
                      }
                    }
                    text
                  }
                  citationDisplayType
                  next_query_suggestions {
                    query
                  }
                  response_type
                  content
                  id
                }
                resourceId
              }
            }
          }`,
            variables: {
                // guestSessionId: `${chatIdRef.current ?? uuidv4()}`,
                guestSessionId: window.location.pathname.split("/chat/")[1] || uuidv4(), //`${user?.email}-${project._id ? project._id : ""}`,
                sessionId: `${organizationName}-${chatAssistantName}-${uuidv4()}`,
                name: encodeParam(assistantName),
                organizationName: encodeParam("techolution"),
                aiModel: encodeParam("claude-35-sonnet"),
                prompt: replyMessage === ""
                    ? encodeParam(formattedQuery)
                    : encodeParam(replyMessage + "\n" + formattedQuery),
                userName: encodeParam(user?.provider?.name), //encodeParam("yash-mathur"),
                userEmailId: encodeParam(user?.email), //encodeParam("yash.mathur@techolution.com"),
                userId: encodeParam("0804b20a-2414-40c8-afd1-1bf0703e9d6e"),
                requestId: encodeParam(requestId),
                replyMessage: replyMessage,
                // customPrompt: props?.generatedPrompt,
                notificationSessionId: sessionId,
                images: JSON.stringify([]),
            },
        });
        let event;
        const accordianMessageArray = [];
        for await (event of subscription) {
            setIsStreaming(true);
            setRenderDone(false);
            let streamedresponse = { role: "assistant", content: "", id: uuidv4() };
            if (event.data.chatStream.continueChatResult.message.content.includes("WaitMessage: ")) {
                setMessageLoading(false);
                setWaitMessageLoading(true);
                streamedresponse.content = extractWaitMessage(event.data.chatStream.continueChatResult.message.content + "\n\n");
                //@ts-ignore
                setStreamingMessages([
                    ...streamingMessages,
                    {
                        role: "user",
                        content: query,
                        time: userQuestionTime,
                        id: requestId,
                        reply: replyMessage,
                    },
                    // streamedresponse,
                ]);
            }
            else {
                setRenderDone(false);
                setMessageLoading(false);
                setWaitMessageLoading(false);
                streamedresponse.content = replaceAsteriskInAnchor(event.data.chatStream.continueChatResult.message.content)?.replace(/WaitMessage: /g, "");
                const { assistantObject, isEnd } = getAssistantObj(event, accordianMessageArray);
                let additionalMessage = [];
                try {
                    if (assistantObject.content) {
                        // console.log("assistantObject.content", assistantObject.content);
                        const parsedContent = JSON.parse(assistantObject.content);
                        // so we have to allow chat when user has persona or not
                        // if user has persona, then modeHistory will be having at least one mode (ex: Project Mode)
                        // ese modeHistory will be empty []
                        if (parsedContent.mode &&
                            (modesHistory.length === 0 ||
                                (modesHistory.length > 0 &&
                                    parsedContent.mode !==
                                        modesHistory[modesHistory.length - 1].mode))) {
                            additionalMessage = [assistantObject];
                        }
                    }
                }
                catch (error) {
                    console.error("Error parsing assistantObject.content:", error.message);
                    showToast("error", "Error", "Failed to process message"); // commenting this for today
                    const errorMessage = {
                        role: "assistant",
                        time: new Date(),
                        id: uuidv4(),
                        content: "Oops! Not what we expected : " + assistantObject.content,
                    };
                    setStreamingMessages((prevMessages) => [...prevMessages, errorMessage]);
                    break;
                }
                const newMessages = [
                    ...streamingMessages,
                    {
                        role: "user",
                        content: query,
                        time: userQuestionTime,
                        id: event.data.chatStream.continueChatResult.requestId ?? "",
                        requestId: event.data.chatStream.continueChatResult.requestId ?? "",
                        reply: replyMessage,
                    },
                    ...additionalMessage,
                ];
                if (isEnd) {
                    setStreamingMessages(newMessages);
                    const neededChatId = chatId || newChatId || chatIdRef.current;
                    if (neededChatId) {
                        if (user && user.email) {
                            await updateUserChatAndHistory(user?.email, neededChatId, newMessages);
                        }
                    }
                    else {
                        console.warn("chat Id not found, so could not update chat history");
                    }
                }
                if (event?.data?.chatStream?.continueChatResult?.isEnd) {
                    try {
                        const parsedWidgetTypeData = JSON.parse(event?.data?.chatStream?.continueChatResult?.message?.content);
                        setIsStreaming(false);
                        if ("mode" in parsedWidgetTypeData) {
                            if (parsedWidgetTypeData["mode"] === "chat") {
                                setResponseMessage((prev) => [
                                    ...prev,
                                    { role: "assistant", content: parsedWidgetTypeData["widget"] },
                                ]);
                            }
                            else {
                                const lastMode = modesHistory[modesHistory.length - 1]?.mode;
                                if (parsedWidgetTypeData["mode"] === HOST_MODES["Project Mode"]) {
                                    setCurrentHostMode(parsedWidgetTypeData["mode"]);
                                    setIsCurrentHostChanged(true);
                                    setModesHistory((prev) => [
                                        ...prev,
                                        {
                                            mode: parsedWidgetTypeData["mode"],
                                            openedBy: "chatAI",
                                        },
                                    ]);
                                    // load the host once again if already a host mode is loaded ; hot fix for now; but in future we have to maintain a logs
                                    // only setting up isHostLoaded to false when last mode is not project mode
                                    if (hostLoadedInfo?.isLoaded &&
                                        hostLoadedInfo.modeName !== HOST_MODES["Project Mode"]
                                    // Old code
                                    // lastMode &&
                                    // lastMode !== HOST_MODES["Project Mode"]
                                    ) {
                                        // console.log(
                                        //   "A Host mode is already loaded so setting up isHostLoaded to false"
                                        // );
                                        setHostLoadedInfo({ isLoaded: false, modeName: "" });
                                        // old code
                                        // setIsHostLoaded(false);
                                    }
                                }
                                else if (parsedWidgetTypeData["mode"] === HOST_MODES["Feedback Mode"]) {
                                    if ("widget" in parsedWidgetTypeData) {
                                        const feedbackData = parsedWidgetTypeData["widget"];
                                        let lastMode = modesHistory[modesHistory.length - 1]?.mode;
                                        lastMode = lastMode ? lastMode : "Creative Workspace";
                                        lastMode = HOST_MODES[lastMode]
                                            ? "Creative Workspace"
                                            : lastMode;
                                        if (feedbackData === HOST_MODES["Feedback Mode"] ||
                                            feedbackData.toLowerCase() === "feedback mode") {
                                            triggerFeedback({
                                                feedbackData: {
                                                    originalContent: "",
                                                },
                                                modeName: lastMode || "Creative Workspace",
                                                modeAssistantName: modeNameToAssistantName[lastMode] ||
                                                    chatAssistantName ||
                                                    config.VITE_ASSISTANT_NAME,
                                            });
                                        }
                                        else {
                                            triggerFeedback({
                                                feedbackData: {
                                                    originalContent: parsedWidgetTypeData["widget"], // which has user query
                                                },
                                                modeName: lastMode || "Creative Workspace",
                                                modeAssistantName: modeNameToAssistantName[lastMode] ||
                                                    chatAssistantName ||
                                                    config.VITE_ASSISTANT_NAME,
                                            });
                                        }
                                    }
                                }
                                else if (parsedWidgetTypeData["mode"] === HOST_MODES["Drive Mode"]) {
                                    setCurrentHostMode(parsedWidgetTypeData["mode"]);
                                    setIsCurrentHostChanged(true);
                                    setModesHistory((prev) => [
                                        ...prev,
                                        {
                                            mode: parsedWidgetTypeData["mode"],
                                            openedBy: "chatAI",
                                        },
                                    ]);
                                    // load the host once again if already a host mode is loaded ; hot fix for now; but in future we have to maintain a logs
                                    // only setting up isHostLoaded to false when last mode is not drive mode
                                    if (hostLoadedInfo?.isLoaded &&
                                        hostLoadedInfo.modeName !== HOST_MODES["Drive Mode"]
                                    // Old code
                                    // lastMode &&
                                    // lastMode !== HOST_MODES["Drive Mode"]
                                    ) {
                                        // console.log(
                                        //   "A Host mode is already loaded so setting up isHostLoaded to false"
                                        // );
                                        setHostLoadedInfo({ isLoaded: false, modeName: "" });
                                        // old code
                                        // setIsHostLoaded(false);
                                    }
                                }
                                else if (parsedWidgetTypeData["mode"] === HOST_MODES["Jira Mode"]) {
                                    setCurrentHostMode(parsedWidgetTypeData["mode"]);
                                    setIsCurrentHostChanged(true);
                                    setModesHistory((prev) => [
                                        ...prev,
                                        {
                                            mode: parsedWidgetTypeData["mode"],
                                            openedBy: "chatAI",
                                        },
                                    ]);
                                    // load the host once again if already a host mode is loaded ; hot fix for now; but in future we have to maintain a logs
                                    // only setting up isHostLoaded to false when last mode is not jira mode
                                    if (hostLoadedInfo?.isLoaded &&
                                        hostLoadedInfo.modeName !== HOST_MODES["Jira Mode"]
                                    // Old code
                                    // lastMode &&
                                    // lastMode !== HOST_MODES["Drive Mode"]
                                    ) {
                                        // console.log(
                                        //   "A Host mode is already loaded so setting up isHostLoaded to false"
                                        // );
                                        setHostLoadedInfo({ isLoaded: false, modeName: "" });
                                        // old code
                                        // setIsHostLoaded(false);
                                    }
                                }
                                else if (parsedWidgetTypeData["mode"] === HOST_MODES["Email Mode"]) {
                                    setCurrentHostMode(parsedWidgetTypeData["mode"]);
                                    setIsCurrentHostChanged(true);
                                    setModesHistory((prev) => [
                                        ...prev,
                                        {
                                            mode: parsedWidgetTypeData["mode"],
                                            openedBy: "chatAI",
                                        },
                                    ]);
                                    if (hostLoadedInfo?.isLoaded &&
                                        hostLoadedInfo.modeName !== HOST_MODES["Email Mode"]) {
                                        // console.log(
                                        //   "A Host mode is already loaded so setting up isHostLoaded to false"
                                        // );
                                        setHostLoadedInfo({ isLoaded: false, modeName: "" });
                                        // old code
                                        // setIsHostLoaded(false);
                                    }
                                }
                                else {
                                    setActiveMode(parsedWidgetTypeData["mode"]);
                                    setIsWidgetTypeChange(true);
                                    setModesHistory((prev) => [
                                        ...prev,
                                        {
                                            mode: parsedWidgetTypeData["mode"],
                                            openedBy: "chatAI",
                                        },
                                    ]);
                                    // load the remote once again if already a remote mode is loaded ; hot fix for now; but in future we have to maintain a logs
                                    // only setting up isRemoteLoaded to false when last mode is not remote mode
                                    if (remoteLoadedInfo?.isLoaded &&
                                        remoteLoadedInfo.modeName !== parsedWidgetTypeData["mode"]
                                    // Old code
                                    // lastMode &&
                                    // lastMode !== parsedWidgetTypeData["mode"]
                                    ) {
                                        // console.log(
                                        //   "A Remote mode is already loaded so setting up isRemoteLoaded to false"
                                        // );
                                        setRemoteLoadedInfo({ isLoaded: false, modeName: "" });
                                        // old code
                                        // setIsRemoteLoaded(false);
                                    }
                                }
                            }
                        }
                    }
                    catch (error) {
                        console.error("Error in message processing:", error.message);
                        showToast("error", "Error", "Failed to process message"); // commenting this for today
                        const errorMessage = {
                            role: "assistant",
                            time: new Date(),
                            id: uuidv4(),
                            content: "Oops! Not what we expected : " + event?.data?.chatStream?.continueChatResult?.message?.content,
                        };
                        setStreamingMessages((prevMessages) => [...prevMessages, errorMessage]);
                    }
                    // Break the loop when processing is complete
                    break;
                }
            }
        }
    }
    catch (error) {
        console.error("Error in message processing:", error.message);
        showToast("error", "Error", "Failed to process message"); // commenting this for today
        const errorMessage = {
            role: "assistant",
            time: new Date(),
            id: uuidv4(),
            content: error.message,
        };
        setStreamingMessages((prevMessages) => [...prevMessages, errorMessage]);
        // throw error; // added in the streaming messages thats why commented
    }
    finally {
        // console.log("Starting WebSocket cleanup in finally block");
        if (client) {
            try {
                const socket = client?.socket;
                await client.dispose();
                if (socket) {
                    const socketState = ["CONNECTING", "OPEN", "CLOSING", "CLOSED"][socket.readyState] ||
                        "UNKNOWN";
                    console.log(`WebSocket state after dispose: ${socketState} (${socket.readyState})`);
                    if (socket.readyState === WebSocket.CLOSED) {
                        console.log("WebSocket connection closed successfully");
                    }
                    else {
                        console.warn(`WebSocket not fully closed. Current state: ${socketState}`);
                    }
                }
                else {
                    console.log("WebSocket connection disposal completed");
                }
            }
            catch (error) {
                console.error("Error during WebSocket cleanup:", error);
            }
        }
        // Reset states
        setMessageLoading(false);
        setWaitMessageLoading(false);
        setIsStreaming(false);
    }
};
